import { Bubble, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { BenefitsData } from './Benefits.data';
import {
  StyledStack,
  BubbleWrapper,
  StyledSection,
  StyledHeadline,
  SingleBenefitWrapper,
  StyledBenefitHeadline,
  StyledBenefitsWrapper,
  SectionNameBannerStack,
  StyledBenefitDescription,
} from './styles';

export const Benefits = ({ ...props }) => {
  const benefits = BenefitsData();

  return (
    <StyledSection
      width="normal"
      mt={{
        xs: 2,
        sm: 4,
        md: 8,
        lg: 12,
      }}>
      <StyledStack {...props}>
        <SectionNameBannerStack>
          <NameBanner type="section" text="Benefits" color="red" />
        </SectionNameBannerStack>
        <StyledHeadline
          display={{ xs: 'none', md: 'block' }}
          variant="display_md"
          paragraph>
          Benefits of choosing
          <br /> Rumble Fish
          <br /> as your AWS cloud
          <br /> solutions partner
        </StyledHeadline>
        <StyledHeadline
          display={{ xs: 'block', md: 'none' }}
          variant="display_md"
          paragraph>
          Benefits of choosing Rumble Fish as your AWS cloud solutions partner
        </StyledHeadline>

        <StyledBenefitsWrapper>
          {benefits.map((el, index) => (
            <SingleBenefitWrapper key={index}>
              <BubbleWrapper>
                <Bubble
                  params={{
                    name: `benefits_${el.name}`,
                    icon: el.icon,
                    top: 0,
                    left: 0,
                    size: 100,
                    boxShadow: el.boxShadow,
                    floatingY: el.floatingY,
                    duration: el.duration,
                  }}
                />
              </BubbleWrapper>
              <StyledBenefitHeadline variant="strong_500">
                {el.title}
              </StyledBenefitHeadline>

              <StyledBenefitDescription variant="regular_400">
                {el.description}
              </StyledBenefitDescription>
            </SingleBenefitWrapper>
          ))}
        </StyledBenefitsWrapper>
      </StyledStack>
    </StyledSection>
  );
};
